export const MQTT_CONFIG = {
    connectionId: 'default',
    url: 'dev-01.sadinhub.net',
    protocol: 'wss',
    manualConnect: true,
    // port: 433,
    host: 'dev-01.sadinhub.net',
    path: '/mqtt',
    topicPrefix: 'v1/ext/',
    connectOnCreate: true,
    keepalive: 30, 
    connectTimeout: 15 * 1000,
    reconnectPeriod: 5 * 1000,
    protocolId: 'MQTT',
    protocolVersion: 5,
} as const;